import { copyToClipboard } from "@freightsimple/ui-core/Feedback/copyToClipboard";
import { DevValueRow, type DevMenuTone } from "./DevMenuPrimitives";
import { useViewportSize } from "./useViewportSize";

interface ViewportRowProps {
  indented?: boolean | undefined;
  tone?: DevMenuTone | undefined;
}

/**
 * Live `width × height` of the browser viewport. Click to copy the label —
 * handy when the team is discussing how a screen behaves at a specific size.
 */
export function ViewportRow({ indented, tone }: ViewportRowProps) {
  const viewport = useViewportSize();
  const label = `${viewport.width} × ${viewport.height}`;
  return (
    <DevValueRow
      label="Viewport"
      value={label}
      onClick={() => copyToClipboard(label, "Viewport")}
      indented={indented}
      tone={tone}
    />
  );
}
